import { render, staticRenderFns } from "./MenuTable.vue?vue&type=template&id=5d0d3937&scoped=true"
import script from "./MenuTable.vue?vue&type=script&lang=js"
export * from "./MenuTable.vue?vue&type=script&lang=js"
import style0 from "./MenuTable.vue?vue&type=style&index=0&id=5d0d3937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d3937",
  null
  
)

export default component.exports